import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";

// helpers
import {
  addBanner as addBannerApi,
  getBanner as getBannerApi,
  deleteBanner as deleteBannerApi,
} from "../../helpers";

// actions
import {
  bannerApiResponseSuccess,
  bannerApiResponseError,
  getBanner,
} from "./actions";

// constants
import { BannerActionTypes } from "./constants";
import { deleteBannerImageApi, updateBanner } from "../../helpers/api/banner";

interface bannerData {
  payload: {
    id: number;
    heading: string;
    heading_ar: string;
    non_animate_text: string;
    non_animate_text_ar: string;
    animate_text: string;
    animate_text_ar: string;
    para: string;
    para_ar: string;
    ids: string[];
    image: File[] | null;
  };
  type: string;
}

function* createBanner({
  payload: {
    heading,
    heading_ar,
    non_animate_text,
    non_animate_text_ar,
    animate_text,
    animate_text_ar,
    para,
    para_ar,
    image,
  },
  type,
}: bannerData): SagaIterator {
  try {
    const response = yield call(
      addBannerApi,
      {
        heading,
        heading_ar,
        non_animate_text,
        non_animate_text_ar,
        animate_text,
        animate_text_ar,
        para,
        para_ar,
      },
      image
    );

    const bannerData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(
      bannerApiResponseSuccess(BannerActionTypes.CREATE_BANNER, bannerData)
    );
    yield put(getBanner());
  } catch (error: any) {
    yield put(bannerApiResponseError(BannerActionTypes.CREATE_BANNER, error));
  }
}
function* UpdateBanner({
  payload: {
    id,
    heading,
    heading_ar,
    non_animate_text,
    non_animate_text_ar,
    animate_text,
    animate_text_ar,
    para,
    para_ar,
    image,
  },
  type,
}: bannerData): SagaIterator {
  try {
    const response = yield call(
      updateBanner,
      id,
      {
        heading,
        heading_ar,
        non_animate_text,
        non_animate_text_ar,
        animate_text,
        animate_text_ar,
        para,
        para_ar,
      },
      image
    );
    

    const bannerData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(
      bannerApiResponseSuccess(BannerActionTypes.UPDATE_BANNER, bannerData)
    );
    yield put(getBanner());
  } catch (error: any) {
    

    yield put(bannerApiResponseError(BannerActionTypes.UPDATE_BANNER, error));
  }
}

function* getBanners(): SagaIterator {
  try {
    const response = yield call(getBannerApi);
    const bannerData = response?.data?.banners;

    yield put(
      bannerApiResponseSuccess(BannerActionTypes.GET_BANNER, bannerData)
    );
  } catch (error: any) {
    yield put(bannerApiResponseError(BannerActionTypes.GET_BANNER, error));
  }
}

function* deleteBanner({ payload: { id } }: bannerData): SagaIterator {
  try {
    const response = yield call(deleteBannerApi, id);
    const bannerData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(
      bannerApiResponseSuccess(BannerActionTypes.DELETE_BANNER, bannerData)
    );
    yield put(getBanner());
  } catch (error: any) {
    yield put(bannerApiResponseError(BannerActionTypes.DELETE_BANNER, error));
  }
}

function* deleteBannerImage({ payload: { ids } }: bannerData): SagaIterator {
  try {
    const response = yield call(deleteBannerImageApi, ids);
    const bannerData = response.data.message;
    // NOTE - You can change this according to response format from your api

    yield put(
      bannerApiResponseSuccess(
        BannerActionTypes.DELETE_BANNER_IMAGE,
        bannerData
      )
    );
  } catch (error: any) {
    yield put(
      bannerApiResponseError(BannerActionTypes.DELETE_BANNER_IMAGE, error)
    );
  }
}

export function* watchCreateBanner() {
  yield takeEvery(BannerActionTypes.CREATE_BANNER, createBanner);
}
export function* watchUpdateBanner() {
  yield takeEvery(BannerActionTypes.UPDATE_BANNER, UpdateBanner);
}
export function* watchGetBanner() {
  yield takeEvery(BannerActionTypes.GET_BANNER, getBanners);
}
export function* watchDeleteBanner() {
  yield takeEvery(BannerActionTypes.DELETE_BANNER, deleteBanner);
}
export function* watchDeleteBannerImage() {
  yield takeEvery(BannerActionTypes.DELETE_BANNER_IMAGE, deleteBannerImage);
}

function* BannerSaga() {
  yield all([
    fork(watchCreateBanner),
    fork(watchDeleteBanner),
    fork(watchDeleteBannerImage),
    fork(watchGetBanner),
    fork(watchUpdateBanner),
  ]);
}

export default BannerSaga;
